
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,
  SET_BUS_SEQ_CODE: (state, payload) => state.busSeqCode = payload,

  SET_MAX_VALUES: (state, payload) => {
    state.nextSeqCode = payload.areaId
    state.busSeqCode = payload.basSection
    state.fromKP = payload.fromKP
  },

  SET_AREAS: (state, payload) => state.areas = payload,
}